import api from "@src/variables/api";
import baseProvider from "./base-provider";

export default {
  ...baseProvider({ url: api.ngayTruc }),
};
